module.exports = __webpack_public_path__ + "static/img/jigou-jiangxi-bottom.0bdfddf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-jiangxi-bottom.png
// module id = lgyW
// module chunks = 2